import React, { Suspense, lazy, useState } from 'react';
import './App.scss';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
// import NavbarComponents from './shared/NavbarComponents';
import { getEncryptedLocalStorageItem, setEncryptedLocalStorageItem } from './utils/localStorage';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Loader from './utils/loadingComponent';
import { PrivateLoginRoute, PrivateRoute } from './utils/authUtil';
import { ToastContainer } from 'react-toastify';
import NotificationsComponent from './components/NotificationsComponent';
import DarkModeContext from './utils/DarkModeContext';
// import { DarkMode } from '@mui/icons-material';


const NavbarComponents = lazy(() => import('./shared/NavbarComponents'));
const LoginComponent = lazy(() => import('./components/LoginComponent'));
const DashboardComponent = lazy(() => import('./components/Dashboard/DashboardComponent'));
const DeviceListComponent = lazy(() => import('./components/DeviceListComponent'));
const InstallationComponent = lazy(() => import('./components/InstallationComponent'));
const InstallationBundleComponent = lazy(() => import('./components/InstallationBundleComponent'));
const ProfileComponent = lazy(() => import('./components/ProfileComponent'));
// const NotificationsComponent = lazy(() => import('./components/NotificationsComponent'));


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});


const lightTheme = createTheme({
  palette: {
    mode: 'light',
  },
});


function App() {
  const getCurrentTheme = getEncryptedLocalStorageItem("dark-mode") != null
    ? getEncryptedLocalStorageItem("dark-mode")
    : window.matchMedia("(prefers-color-scheme: dark)").matches;

  // Initialize the theme state with dark theme as the default
  const [currentTheme, setCurrentTheme] = useState(getCurrentTheme ? darkTheme : lightTheme);

  // Function to toggle between dark and light themes
  const toggleTheme = () => {
    setCurrentTheme(currentTheme === darkTheme ? lightTheme : darkTheme);
    setEncryptedLocalStorageItem("dark-mode", currentTheme === darkTheme ? false : true);
  };

  const [sibling, setSibling] = useState(false);

  const eventData = (data) => {
    setSibling(data);
  }

  return (

   <DarkModeContext.Provider value={{darkTheme, toggleTheme}}>
     <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <BrowserRouter basename="/">
        <ToastContainer limit={1} />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              exact
              path="/dashboard"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} />
                    <DashboardComponent
                      title="Dashboard"
                      currentTheme={currentTheme === darkTheme}
                    />
                  </>
                } />
              }
            />

            <Route
              exact
              path="/devices"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} />
                    <DeviceListComponent
                      title="Device List"
                      currentTheme={currentTheme === darkTheme}
                    />
                  </>
                } />
              }
            />

            <Route
              exact
              path="/notifications"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} sibling={sibling} />
                    <NotificationsComponent
                      title="Notifications"
                      currentTheme={currentTheme === darkTheme}
                      eventData={eventData}
                    />
                  </>
                } />
              }
            />


            <Route
              exact
              path="/installation"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} />
                    <InstallationComponent
                      title="My Installations"
                    />
                  </>
                } />
              }
            />

            <Route
              exact
              path="/installation-bundle/:id"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} />
                    <InstallationBundleComponent
                      title="My Installation Bundle"
                    />
                  </>
                } />
              }
            />

            <Route
              exact
              path="/profile"
              element={
                <PrivateRoute element={
                  <>  <NavbarComponents currentTheme={currentTheme} toggleTheme={toggleTheme} />
                    <ProfileComponent title="My Profile" currentTheme={currentTheme === darkTheme} />
                  </>
                } />
              }
            />


    

            <Route
              exact
              path="/login"
              element={
                <PrivateLoginRoute element={
                  <LoginComponent
                    currentTheme={currentTheme === darkTheme} toggleTheme={toggleTheme}
                    title="Login"
                  />
                } />
              }
            />

            <Route path="*" element={<Navigate to={{ pathname: "/dashboard" }} />} />

          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
   </DarkModeContext.Provider>
  );
}

export default App;
